import React from 'react'
import { Modal } from 'react-bootstrap'
import { PropagateLoader } from 'react-spinners'
import { Rating } from 'react-simple-star-rating'
import 'react-perfect-scrollbar/dist/css/styles.css'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { useSelector } from 'react-redux'

export default function FeedbackDetails(props) {

    const { detailLoading, setDetailLoading, detailModal, setDetailModal, detailModalData, setDetailModalData } = props

    const details = useSelector(state => state.feedbackDetails && state.feedbackDetails.data && state.feedbackDetails.data.data)

    const handleClose = () => {
        setDetailModal(false)
        setDetailLoading(true)
        setDetailModalData()
    }

    return (
        <>
            <Modal show={detailModal} onHide={handleClose} centered size="xl" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Feedback Rating</Modal.Title>
                </Modal.Header>

                <PerfectScrollbar>
                    <Modal.Body>

                        {detailLoading ?
                            <div className='text-center mb-3'>
                                <PropagateLoader
                                    color="#2262C6"
                                    size={20}
                                />
                            </div>
                            :
                            <div style={{ height: '75vh' }}>

                                <div className="d-flex justify-content-between align-items-baseline">
                                    <span style={{ color: '#9d9d9d' }}>Employee</span>
                                    <h6>{detailModalData && detailModalData.user_name}</h6>
                                </div>

                                <div className="d-flex justify-content-between align-items-baseline">
                                    <span style={{ color: '#9d9d9d' }}>Learning Module</span>
                                    <h6>{detailModalData && detailModalData.course_name}</h6>
                                </div>

                                <div className="d-flex justify-content-between align-items-baseline">
                                    <span style={{ color: '#9d9d9d' }}>Instructor Name</span>
                                    <h6>{detailModalData && detailModalData.instructor_name}</h6>
                                </div>

                                <div className="d-flex justify-content-between align-items-baseline">
                                    <span style={{ color: '#9d9d9d' }}>Created On</span>
                                    <h6>{detailModalData && detailModalData.submitted_date}</h6>
                                </div>

                                <hr className='hr_line' />

                                {details && details.filter(value => value.question_type == 'rating').map((val, index) =>
                                    <div key={index} className='mb-2'>
                                        {val.question} <br />
                                        <Rating
                                            readonly={true}
                                            initialValue={val.rating}
                                            fillColorArray={[
                                                "#f14f45",
                                                "#f16c45",
                                                "#f18845",
                                                "#f1b345",
                                                "#f1d045"
                                            ]}
                                        />
                                    </div>
                                )}

                                {details && details.filter(value => value.question_type == 'text').map((val, index) =>
                                    <div key={index} className='mb-2'>
                                        <span>{val.question}</span> <br />
                                        <span style={{ color: '#7d7d7d' }}>{val.submit_answer}</span>
                                    </div>
                                )}
                            </div>
                        }

                    </Modal.Body>
                </PerfectScrollbar>
            </Modal>
        </>
    )
}
